import { NgModule } from '@angular/core';
import { PriceModule } from '@icc/price';
import { PriceProfileService } from './price-profile.service';
import { PriceSashService } from './price-sash.service';
import { PriceDoorService } from './price-door.service';
import { PriceAccessoryService } from '@icc/construction-elements/configurator';
import { PriceGlazingService } from './price-glazing.service';
import { PriceSealService } from './price-seal.service';
import { PriceSiliconeService } from './price-silicone.service';
import { PriceMuntinsService } from './price-muntins.service';
import { PriceHandlesService } from './price-handles.service';
import { PriceFittingService } from './price-fitting.service';
import { PriceHandlePositionService } from './price-handle-position.service';
import { PriceCoupledWindowService } from './price-coupled-window.service';
import { PriceShapeService } from './price-shape.service';
import { PriceOuterDoorService } from './price-outer-door.service';
import { PriceDependenciesService } from './price-dependencies.service';
import { PriceColorsService } from '@icc/construction-elements/configurator';
import { PriceSystemService } from './price-system.service';
import { WarrantyService } from './warranty.service';

@NgModule({
    imports: [PriceModule],
    providers: [
        PriceColorsService,
        PriceSystemService,
        WarrantyService,
        PriceProfileService,
        PriceSashService,
        PriceDoorService,
        PriceAccessoryService,
        PriceGlazingService,
        PriceSealService,
        PriceSiliconeService,
        PriceMuntinsService,
        PriceHandlesService,
        PriceFittingService,
        PriceHandlePositionService,
        PriceCoupledWindowService,
        PriceShapeService,
        PriceOuterDoorService,
        PriceDependenciesService,
    ],
})
export class WindowDoorPriceModule {}
